// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-ed5e66","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-bfc7e8","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-6b4b74"};